import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "./assets/style.css";
import { auth, db } from "./firebase";
import { Element, scroller } from "react-scroll";
import firebase from "firebase/compat/app";

const Chapter3_2 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question: "Frage 1: Was ist das Hauptziel eines Ransomware-Angriffs?",
      options: [
        {
          value: "A",
          label:
            "Systeme und Daten zu verschlüsseln, um Lösegeld zu verlangen.",
        },
        {
          value: "B",
          label:
            "Daten direkt zu löschen, um das Unternehmen handlungsunfähig zu machen.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Wie kann man sich am effektivsten vor einem Ransomware-Angriff schützen?",
      options: [
        {
          value: "A",
          label: "Regelmäßige Backups und Schulung der Mitarbeiter.",
        },
        {
          value: "B",
          label: "Ausschließlich Antivirenprogramme helfen gegen Ransomware.",
        },
      ],
      correct: "A",
    },
  ];

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);

 
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

   
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 3_2.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "3_2",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("3_2"),
            });
          console.log("Dokument aktualisiert mit Kapitel 3_2.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "3_2",
              completedChapters: ["3_2"],
            });
          console.log("Dokument erstellt mit Kapitel 3_2");
        }

        navigate("/3_3"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  3. Angriffe und Risiken
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Ransomware
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">Kapitel 3: Angriffe und Risiken</h3>
          <h2 className="text-center p-3">Ransomware</h2>
          <img
            src="/images/ransom.webp"
            alt="Ransom"
            style={{ position: "relative", maxWidth: "30%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <p className="col-lg-11 pt-5 mx-auto">
            Ransomware zählt grundsätzlich zu{" "}
            <Link to="/3_1" className="icon-link">
              {" "}
              <svg className="bi" aria-hidden="true">
                {" "}
                <use xlinkHref="#book"></use>{" "}
              </svg>{" "}
              Malware,{" "}
            </Link>{" "}
            da auch hier schädlicher Code den Computer infiziert. Ransomware
            verschlüsselt Dateien auf einem System. Besonders ist aber hierbei,
            dass nach dem Angriff der Täter mit dem Opfer interagiert, um
            Lösegeld für die Bereitstellung des Schlüssels zum Entschlüsseln
            (Decryption Key) zu verlangen. Ransomware dient also zur
            finanziellen Erpressung.
          </p>

          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            2024 lag die durchschnittliche Lösegeldzahlung von deutschen
            Unternehmen nach einem Ransomware-Angriff bei 5,14 Mio Euro. Hinzu
            kamen weitere Kosten von durchschnittlich 2,1 Mio. Euro für die
            Wiederherstellung, Ausfallzeiten, Personalzeit, Gerätekosten,
            Netzwerkkosten oder entgangene Geschäftschancen. (Sophos, State of
            Ransomware 2024)
          </p>
        </div>
      </div>

      <div className="grey-section">
        <div className="container">
          <div className="p-5 text-center">
            <h3 className="p-5">Wie läuft ein Ransomwareangriff ab?</h3>

            <section class="p-5 col-lg-10 mx-auto text-start">
              <ul class="timeline">
                <li class="timeline-item mb-5">
                  <h5 class="fw-bold">1. Zielauswahl und Vorbereitung</h5>

                  <p>
                    Angreifer wählen potenzielle Opfer wie Unternehmen oder
                    Behörden aus, meist basierend auf deren Zahlungsfähigkeit.
                    Über Schwachstellen-Scanning oder{" "}
                    <Link to="/2_5" className="icon-link">
                      {" "}
                      <svg className="bi" aria-hidden="true">
                        {" "}
                        <use xlinkHref="#book"></use>{" "}
                      </svg>{" "}
                      Social Engineering{" "}
                    </Link>{" "}
                    sammeln sie Informationen und passen die Ransomware an, um
                    Sicherheitslösungen zu umgehen.
                  </p>
                </li>

                <li class="timeline-item mb-5">
                  <h5 class="fw-bold">2. Zugang zum Zielsystem</h5>

                  <p>
                    Der Erstzugang erfolgt häufig durch{" "}
                    <Link to="/2_4" className="icon-link">
                      {" "}
                      <svg className="bi" aria-hidden="true">
                        {" "}
                        <use xlinkHref="#book"></use>{" "}
                      </svg>{" "}
                      Phishing.{" "}
                    </Link>
                    Alternativ nutzen Angreifer Schwachstellen in ungepatchten
                    Systemen, schwache Passwörter{" "}
                    <Link to="/2_3#brute" className="icon-link">
                      <svg className="bi" aria-hidden="true">
                        <use xlinkHref="#book"></use>
                      </svg>{" "}
                      (Brute-Force-Angriff)
                    </Link>{" "}
                    oder infizierte Geräte wie USB-Sticks aus.
                  </p>
                </li>

                <li class="timeline-item mb-5">
                  <h5 class="fw-bold">
                    3. Verbreitung innerhalb des Netzwerks
                  </h5>

                  <p>
                    Sobald die Malware das Zielgerät infiziert hat, liefert es
                    Rückmeldung an einen sogenannten Command-and-Control Server
                    des Angreifers. Von diesem Server aus wird anschließend der
                    Encryption Key (Schlüssel, der Daten verschlüsselt) versandt.
                    Gleichzeitig erkundet die Malware durch sogenannte
                    Seitwärtsbewegungen das Zielgerät. Mit Tools wie{" "}
                    <span
                      data-tooltip-id="tooltip-mimi"
                      data-tooltip-content="Mimikatz ist ein bekanntes Open-Source-Tool, das von Sicherheitsexperten und Hackern gleichermaßen verwendet wird, um Windows-Systeme auf Schwachstellen in der Authentifizierung zu untersuchen. Es ermöglicht das Auslesen von Passwörtern, Hashes und Kerberos-Tickets aus dem Speicher eines Windows-Systems. Obwohl es ursprünglich für Sicherheitsanalysen entwickelt wurde, wird es häufig von Angreifern missbraucht, um sich unbefugten Zugriff auf Netzwerke zu verschaffen."
                      className="custom-tooltip-trigger"
                    >
                      {" "}
                      "Mimikatz"{" "}
                    </span>{" "}
                    verschaffen sich die Angreifer Administratorrechte und
                    breiten sich durch so genannte Seitwärtsbewegungen im
                    Netzwerk aus. Sie sammeln Informationen darüber, wie man auf
                    weitere Geräte des Netzwerks zugreifen kann oder suchen
                    gezielt nach den wichtigsten Systemen oder interessantesten
                    Dateien.
                  </p>
                  <ReactTooltip
                    id="tooltip-mimi"
                    place="top"
                    className="custom-tooltip"
                  />
                </li>

                <li class="timeline-item mb-5">
                  <h5 class="fw-bold">4. Verschlüsselung der Daten</h5>

                  <p>
                    Der Verschlüsselungsprozess wird meist außerhalb der
                    Arbeitszeiten aktiviert, um die Entdeckung zu verzögern.
                    Starke Algorithmen wie{" "}
                    <span
                      data-tooltip-id="tooltip-aes"
                      data-tooltip-content="AES-256 (Advanced Encryption Standard mit einer Schlüssellänge von 256 Bit) ist ein symmetrisches Verschlüsselungsverfahren, das weltweit als einer der sichersten Standards für die Datenverschlüsselung gilt. Mit einem 256-Bit-Schlüssel bietet AES eine enorme Anzahl möglicher Schlüsselvariationen, die es praktisch unmöglich machen, die Verschlüsselung durch Brute-Force-Angriffe zu knacken. Es wird häufig in Bereichen wie Online-Banking, Cloud-Speicherung und staatlichen Sicherheitsanwendungen eingesetzt, um sensible Daten zu schützen."
                      className="custom-tooltip-trigger"
                    >
                      {" "}
                      AES-256{" "}
                    </span>{" "}
                    sichern die Daten, und oft werden neben lokalen Dateien auch
                    Netzlaufwerke und Cloud-Speicher betroffen.
                  </p>
                  <ReactTooltip
                    id="tooltip-aes"
                    place="top"
                    className="custom-tooltip"
                  />
                </li>

                <li class="timeline-item mb-5">
                  <h5 class="fw-bold">5. Lösegeldforderung</h5>

                  <p>
                    Die Angreifer hinterlassen eine Nachricht mit
                    Lösegeldforderungen, meist in Cryptowährungen. Sie geben
                    Anweisungen zur Zahlung, setzen Fristen und drohen bei
                    Nichtzahlung mit der dauerhaften Verschlüsselung und bzw.
                    oder der Veröffentlichung der gestohlener Daten .
                  </p>
                </li>

                <li class="timeline-item mb-5">
                  <h5 class="fw-bold">6. Datendiebstahl (optional)</h5>

                  <p>
                    Oft werden sensible Daten vor der Verschlüsselung noch an
                    den Command-an-Control-Server gesandt. Selbst wenn die Opfer
                    für eine Entsperrung gezahlt haben, können die Täter die
                    Opfer erneut erpressen, diese Daten zu veröffentlichen
                    ("doppelte Erpressung"). Da die kopierten Daten auch Daten
                    von Kunden, Partnern oder Lieferanten sein können, können
                    die Täter bei der "dreifachen Erpressung" auch diese mit der
                    Veröffentlichung der Daten erpressen. Zusätzlich können alle
                    Daten auch noch im Darknet verkauft oder veröffentlicht
                    werden.
                  </p>
                </li>

                <li class="timeline-item mb-5">
                  <h5 class="fw-bold">7. Zahlung oder Nichtzahlung</h5>

                  <p>
                    Manche Opfer zahlen, um ihre Daten zurückzubekommen, obwohl
                    es keine Garantie gibt, dass die Entschlüsselung
                    funktioniert. Ohne Zahlung bleiben die Daten verschlüsselt,
                    wenn keine Backups existieren. Zudem droht immer die Gefahr
                    der Datenveröffentlichung.
                  </p>
                </li>
              </ul>
            </section>
          </div>
        </div>
      </div>
      <div className="white-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h2 className="p-5">
              Folgen von Ransomware-Angriffen auf Unternehmen
            </h2>

            <p className="col-lg-11 mx-auto">
              Ransomware-Angriffe haben erhebliche Auswirkungen auf die Finanzen
              und den Betrieb sowie das Vertrauen in das Unternehmen. Die
              direkten finanziellen Belastungen sind oft enorm. Durchschnittlich
              zahlen Unternehmen bei einem Angriff rund 2 Millionen US-Dollar an
              Lösegeld, während die Kosten für die Wiederherstellung von
              Systemen ohne Lösegeldzahlung bei etwa 2,73 Millionen US-Dollar
              liegen (Sophos, State of Ransomware 2024). Hinzu kommen die
              Aufwendungen für IT-Dienstleister, die bei der Wiederherstellung
              und Absicherung der Systeme helfen. <br />
              <br />
              Außerdem stellen Produktionsausfälle und Umsatzeinbußen für viele
              Unternehmen eine zusätzliche Belastung dar. Studien zeigen, dass
              es im Durchschnitt 22 Tage dauert, bis der Betrieb wieder
              vollständig aufgenommen werden kann. Während 44% der betroffenen
              Unternehmen innerhalb von fünf Tagen wieder arbeitsfähig sind,
              benötigen fast ein Drittel bis zu einem Monat, um sich zu erholen.
              <br />
              <br />
              Die indirekten Folgen solcher Angriffe sind ebenfalls nicht zu
              unterschätzen. Mitarbeiter spüren die Auswirkungen besonders
              deutlich: 45% berichten von einer erhöhten Arbeitsbelastung,
              während 40% angeben, unter stärkerem Stress zu leiden. Dies führt
              bei rund einem Viertel der Belegschaft zu Produktivitätsverlusten,
              was die ohnehin angespannten betrieblichen Abläufe weiter
              beeinträchtigt.
              <br />
              <br />
              Langfristig wirken sich Ransomware-Angriffe auch auf die
              Reputation eines Unternehmens aus. Ein Vertrauensverlust bei
              Kunden ist oft die Folge, und rechtliche Konsequenzen oder
              Compliance-Verstöße können das Risiko zusätzlich erhöhen. Viele
              Unternehmen sehen sich zudem mit steigenden Versicherungsprämien
              konfrontiert, da Anbieter die Risiken durch Cyberangriffe
              zunehmend in ihre Kalkulationen einbeziehen.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Durch Ransomware-Angriffe werden durchschnittlich 41% der
              Unternehmensdaten kompromittiert, wobei nur 57% dieser Daten
              erfolgreich wiederhergestellt werden können. (Veaam, Ransomware
              Trends Report 2024)
            </p>
          </div>
        </div>
      </div>

      <div className="gelb-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h2 className="p-5">
              Eine wachsende Gefahr für Banken und Finanzinstitute
            </h2>

            <p className="col-lg-11 mx-auto">
              Es liegt nahe, dass Banken im Fokus von Ransomware-Angriffen
              liegen: Sie verwalten riesige Vermögenswerte, speichern sensible
              Kundendaten und sind stark von der Verfügbarkeit ihrer Systeme
              abhängig. Ein erfolgreicher Ransomware-Angriff kann unmittelbare
              Folgen haben, wie z. B. den Ausfall von IT-Systemen, so dass
              Kunden auf ihre Konten nicht mehr zugreifen können. Darüber hinaus
              sind Finanz- und Kundendaten sehr begehrt bei den Angreifer.
              <br />
              <br />
              Die Schäden gehen über die rein technischen und finanziellen
              hinaus. Reputationsverluste haben langfristig negative
              Auswirkungen auf die Kundenbindung. Für Banken, die sich in einem
              hart umkämpften Markt bewegen, kann ein Vertrauensverlust zu
              Abwanderungen und einem geschwächten Image führen. Auch rechtliche
              und regulatorische Konsequenzen sind nicht zu unterschätzen,
              insbesondere wenn ein Angriff auf mangelnde Compliance oder
              unzureichende Sicherheitsvorkehrungen zurückzuführen ist.
              <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
                <img
                  src="/images/attack.svg"
                  alt="Angriff"
                  style={{
                    position: "relative",
                    maxWidth: "10%",
                    height: "auto",
                  }}
                />
                Für den Finanzsektor insgesamt weltweit nennt Check Point für 2025 451 Ransomware-Vorfälle bei Finanzinstituten (nach 269 im Vorjahr). In der Sophos-Erhebung The State of Ransomware in Financial Services 2024 lag der durchschnittliche Wiederherstellungsaufwand nach einem Ransomware-Angriff in Finanzinstituten bei 2,58 Mio. USD (ohne dass das zwingend die Lösegeldzahlung sein muss), und die median gezahlte Lösegeldsumme lag bei 2 Mio. USD.
              </p>
            </p>
          </div>
        </div>
      </div>

      <div className="grey-section">
        <div className="container pb-5">
          <div className="p-5 text-center">
            <h2 className="p-5">Wie kann man sich vor Ransomware schützen?</h2>

            <p className="col-lg-11 mx-auto">
              Der Schutz vor Ransomware-Angriffen erfordert eine integrierte
              Strategie, die technische Lösungen, organisatorische Prozesse und
              die Sensibilisierung von Mitarbeitern miteinander verbindet.
              <br />
              <br />
              Technische Maßnahmen sind erforderlich, um Angriffe frühzeitig zu
              erkennen und abzuwehren. Regelmäßige Backups sind unverzichtbar,
              denn sie ermöglichen es Unternehmen, nach einem Angriff schnell
              wieder operativ zu werden, ohne Lösegeld zahlen zu müssen.
              Antivirensoftware und Firewalls schützen als zentrale
              Verteidigungssysteme vor bekannten Bedrohungen. Eine oft
              unterschätzte, aber essenzielle Maßnahme ist das schnelle
              Einspielen von Sicherheitsupdates. Ungepatchte Schwachstellen in
              Software bieten Cyberkriminellen einen direkten Zugang zu
              Netzwerken. Dieses Risiko kann durch ein konsequentes
              Patch-Management minimiert werden.
              <br />
              <br />
              Technologie allein reicht jedoch nicht aus, wenn menschliches
              Verhalten unberücksichtigt bleibt. Regelmäßige Schulungen der
              Mitarbeiter schaffen Bewusstsein für potenzielle Gefahren und
              vermitteln konkrete Handlungsanweisungen, beispielsweise im Umgang
              mit Phishing-E-Mails.
              <br />
              <br />
              Unternehmen, die für den Ernstfall Notfallpläne mit klaren
              Prozessen und Verantwortlichkeiten definiert haben, können
              schneller und effektiver reagieren. Solche Pläne sollten
              regelmäßig getestet und aktualisiert werden, um auch auf neue
              Bedrohungsszenarien vorbereitet zu sein.
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container pb-5">
          <div className="p-5 text-center">
            <h2 className="p-5">
              Notfallmanagement für einem Ransomware-Angriff
            </h2>

            <p className="col-lg-11 mx-auto">
              Die richtige Reaktion im Ernstfall ist entscheidend, um den
              Schaden zu minimieren und eine schnelle Wiederherstellung der
              Systeme zu gewährleisten. Ein strukturiertes Vorgehen ist dabei
              unerlässlich:
              <section class="p-5 text-start">
                <ul class="timeline">
                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">
                      1. Sofortige Maßnahmen: Isolation der Infektion:
                    </h5>

                    <p>
                      Der erste Schritt in einem Ransomware-Angriffsfall ist die
                      sofortige Trennung der betroffenen Systeme vom Netzwerk.
                      Diese Maßnahme verhindert die weitere Verbreitung der
                      Schadsoftware und minimiert den potenziellen Schaden. Alle
                      infizierten Geräte sollten isoliert und offline genommen
                      werden. Eine schnelle Reaktion ist entscheidend, da jede
                      Verzögerung den Angriff eskalieren lassen könnte.
                    </p>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">
                      2. Benachrichtigung und Koordination: Expertise einholen:
                    </h5>

                    <p>
                      Sobald der Angriff identifiziert ist, muss das interne IT-
                      und Sicherheitsteam umgehend informiert werden. In vielen
                      Fällen ist es ratsam, externe Spezialisten für einen
                      Incident Response hinzuzuziehen. Diese Experten bringen
                      die notwendige Erfahrung mit, um die Infektion zu
                      analysieren, einzudämmen und die nächsten Schritte zu
                      planen. Die enge Zusammenarbeit zwischen internen und
                      externen Teams ist dabei entscheidend für eine
                      koordinierte und effektive Reaktion.
                    </p>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">
                      3. Dokumentation und Analyse: Den Angriff verstehen
                    </h5>

                    <p>
                      Die sorgfältige Dokumentation jedes Details des Angriffs
                      bildet die Basis der späteren Reaktion und Bewertung.
                      Dabei sollten Informationen zur Art der Ransomware, den
                      Lösegeldforderungen und den betroffenen Systemen
                      festgehalten werden. Diese Daten dienen nicht nur der
                      internen Aufarbeitung. Sie sind auch essenziell für
                      Versicherungsansprüche und die Meldung an Behörden. Eine
                      detaillierte Analyse des dokumentierten Vorfalls hilft
                      zudem, Schwachstellen im System zu identifizieren und
                      künftige Angriffe zu verhindern.
                    </p>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">
                      4. Kontakt zu Behörden: Transparenz und Regelkonformität
                    </h5>{" "}
                    <p>
                      Die Benachrichtigung von Strafverfolgungsbehörden, wie der
                      Polizei oder dem Bundesamt für Sicherheit in der
                      Informationstechnik (BSI), ist ein wichtiger Schritt, um
                      rechtliche Unterstützung zu erhalten. Sollte es zu
                      Datenschutzverletzungen gekommen sein, muss die zuständige
                      Datenschutzbehörde innerhalb von 72 Stunden informiert
                      werden. Die frühzeitige Einbindung von Behörden sorgt für
                      Transparenz und reduziert das Risiko rechtlicher
                      Konsequenzen.
                    </p>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">
                      5. Wiederherstellung: Systematisches Vorgehen
                    </h5>

                    <p>
                      Die Wiederherstellung der Systeme erfolgt in mehreren
                      Phasen. Zunächst müssen vorhandene Backups geprüft werden,
                      um sicherzustellen, dass sie nicht kompromittiert sind.
                      Danach wird die Ransomware vollständig aus den betroffenen
                      Systemen entfernt. Die Wiederherstellung erfolgt
                      schrittweise, um sicherzustellen, dass bei der
                      Wiederherstellung nicht auch die Infektion
                      wiederhergestellt wird, oder infizierte Elemente
                      zurückbleiben. Abschließend sollten alle Schwachstellen
                      identifiziert und behoben werden, um erneute Angriffe zu
                      verhindern.
                    </p>
                  </li>
                </ul>
              </section>
            </p>
          </div>
        </div>
      </div>

      <div className="container">
        <div
          className="safe rounded-2 text-center"
          style={{ backgroundColor: "#fec748" }}
        >
          <img
            src="/images/abwehr.svg"
            alt="Abwehr"
            style={{
              position: "relative",
              maxWidth: "7%",
              height: "auto",
            }}
          />
          <h3 className="p-5">Best Practices für das Backup-Management</h3>
          <Element name="backup">
            <p className="col-lg-11 mx-auto">
              Ein effektives <strong> Backup-Management </strong> stellt sicher,
              dass geschäftskritische Informationen jederzeit verfügbar bleiben
              und die Geschäftskontinuität auch nach einem Ransomangriff
              gesichert werden kann.
              <br />
              <br />
              Ein wesentliches Element ist die regelmäßige{" "}
              <strong>Backup-Erstellung, </strong> bei der Datenkopien auf
              separaten Speichermedien gespeichert werden. Dies geschieht oft
              durch automatisierte Prozesse, die menschliche Fehler minimieren
              und den Aufwand reduzieren. <br />
              <br />
              Man unterscheidet verschiedene Arten von Backups:
              <br />
              <strong>Vollständiges Backup: </strong>Sichert alle Daten in einem
              einzigen Durchlauf. Es ist die umfassendste, aber auch
              ressourcenintensivste Methode. <br />
              <br />
              <strong>Differenzielles Backup: </strong>Sichert alle Änderungen
              seit dem letzten vollständigen Backup. Es ist damit schneller als
              ein vollständiges Backup, benötigt jedoch mehr Speicherplatz als
              ein inkrementelles Backup. <br />
              <br />
              <strong>Inkrementelles Backup: </strong> Speichert nur die
              Änderungen seit dem letzten Backup, wodurch Speicherplatz und Zeit
              gespart werden.
              <br />
              <br />
              Die <strong> strategische Planung </strong> bildet das Fundament
              jedes Backup-Systems. Dazu gehört, genau festzulegen, welche Daten
              gesichert werden sollen, in welchen Intervallen dies geschehen
              muss und welche Speichermedien sich am besten eignen. Eine gute
              Planung sorgt dafür, dass Backups nicht nur umfassend, sondern
              auch effizient und skalierbar sind. Zwei etablierte Prinzipien
              sind besonders hervorzuheben:
              <br />
              <br />
              <strong>3-2-1-Regel: </strong>
              Es existieren mindestens drei Kopien jeder wichtigen Datei. Diese
              werden auf zwei unterschiedlichen Speichermedien aufbewahrt. Eine
              Kopie wird an einem physisch getrennten Standort gespeichert, um
              vor Katastrophen wie Bränden oder Überschwemmungen zu schützen.
              <br />
              <br />
              <strong>Großvater-Vater-Sohn-Prinzip: </strong>
              Bei der täglichen "Sohn"-Sicherung werden von Montag bis
              Donnerstag die Daten auf vier verschiedenen Medien gespeichert und
              wöchentlich überschrieben. Die "Vater"-Sicherung erfolgt jeden
              Freitag auf vier weiteren Medien. Sie wird monatlich
              überschrieben. Die "Großvater"-Sicherung findet am Monatsende
              statt, verwendet zwölf Speichermedien und wird erst nach einem
              Jahr überschrieben. Dieses Rotationssystem ermöglicht sowohl
              schnellen Zugriff auf aktuelle Daten als auch eine langfristige
              Datensicherung bis zu einem Jahr. Es ist besonders für Unternehmen
              geeignet, die ihre Daten zuverlässig und systematisch sichern
              müssen. Es gewährleistet durch die mehrfachen Sicherungskopien
              eine hohe Datensicherheit.
              <br />
              <br />
              Backups sollten <strong> regelmäßig durchgeführt </strong>werden.
              Für geschäftskritische Daten sind tägliche oder sogar stündliche
              Sicherungen sinnvoll.
              <br />
              <br />
              Daten sollten in{" "}
              <strong>verschiedenen geografischen Regionen </strong> gespeichert
              werden, um Schutz vor regionalen Ausfällen zu bieten. Dies
              minimiert das Risiko eines vollständigen Datenverlusts durch
              Naturkatastrophen oder technische Störungen. Die Daten sollten{" "}
              <strong> verschlüsselt </strong> werden, um unbefugten Zugriff zu
              verhindern.
              <strong>
                {" "}
                <br />
                <br />
                Regelmäßige Tests der Wiederherstellbarkeit{" "}
              </strong>{" "}
              sind ebenso unerlässlich, um sicherzustellen, dass Backups im
              Ernstfall zuverlässig funktionieren. Auch eine sorgfältige
              Dokumentation aller Backup-Prozesse hilft, den Überblick zu
              behalten und Prozesse bei Bedarf anzupassen.
              Überwachungsmechanismen und Verifizierungen sorgen dafür, dass
              Backups tatsächlich vollständig und korrekt erstellt wurden.
            </p>
          </Element>
        </div>
      </div>

      {/* Fragenteil */}
      <div className="container pt-5 my-5">
        <div className="text-center m-4">
          <h2>Überprüfe dein Wissen</h2>
          <p className="col-lg-11 mx-auto">
            Mit den richtigen Antworten kommst du weiter!
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-8 text-start">
            <form onSubmit={handleSubmit}>
              {questions.map((question, index) => (
                <div key={index} className="mb-4">
                  <p className="fs-4">{question.question}</p>{" "}
                  {question.options.map((option) => (
                    <div key={option.value} className="form-check">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name={`question${index}`}
                        value={option.value}
                        checked={selectedAnswers[index] === option.value}
                        onChange={() => handleAnswerChange(index, option.value)}
                      />
                      <label className="form-check-label fs-5">
                        {option.label}
                      </label>{" "}
                    </div>
                  ))}
                </div>
              ))}
              {error && <p className="text-danger">{error}</p>}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  überprüfen
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter3_2;
